import type { LocaleCode, LocalizedText } from '@fixit/bozp-content';

/**
 * Resolve a LocalizedText to a display string for `locale`, falling back to the
 * always-present `cs-CZ` value. An empty string in the requested locale is
 * treated as "not authored" and falls through to cs-CZ.
 */
export function resolveLocalized(text: LocalizedText, locale: LocaleCode = 'cs-CZ'): string {
  const candidate = text[locale];
  if (typeof candidate === 'string' && candidate.length > 0) {
    return candidate;
  }
  return text['cs-CZ'];
}
